<template>
  <el-dialog title="工具联调" :visible="visible"
             width="720px" v-dialogDrag :modal-append-to-body="false"
             @update:visible="$emit('update:visible', $event)">
    <div class="test_head">
      <span class="t_name">{{ tool ? tool.name : '' }}</span>
      <el-tag size="small" :type="tool && tool.type === 'http' ? '' : 'warning'">{{ tool && tool.type === 'http' ? 'HTTP' : 'MCP' }}</el-tag>
    </div>
    <el-form label-width="90px">
      <el-form-item label="调用参数">
        <el-input v-model="argsText" type="textarea" :rows="5" class="mono" placeholder='JSON 对象，如 {"q": "hello"}' />
        <div v-if="argsErr" class="json_err">{{ argsErr }}</div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="testing" @click="submitTest">执行联调</el-button>
        <span class="field_tip">超时预算 150 秒，请耐心等待</span>
      </el-form-item>
    </el-form>

    <div v-if="result" class="result_box">
      <h4>执行结果</h4>
      <template v-if="tool && tool.type === 'http'">
        <div class="kv"><span class="k">状态码</span><span :class="statusCodeClass">{{ result.status_code }}</span></div>
        <pre class="stream_pre">{{ result.body || '（空响应体）' }}</pre>
        <el-alert v-if="result.truncated" type="warning" :closable="false"
                  title="响应体超过 64KB 已截断" show-icon />
      </template>
      <template v-else>
        <div v-if="result.text !== undefined && result.text !== null && result.text !== ''">
          <h5>文本输出</h5>
          <pre class="stream_pre">{{ result.text }}</pre>
        </div>
        <div v-if="result.structured !== undefined && result.structured !== null">
          <h5>结构化输出</h5>
          <pre class="stream_pre">{{ fmtJson(result.structured) }}</pre>
        </div>
        <div v-if="isEmptyMcp" class="field_tip">无 text / structured 返回</div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { agentBody } from '../utils'

// 工具联调弹窗：args 用 JSON 文本框（已拍板不做按 args_schema 动态表单）；响应按工具类型分支展示
export default {
  name: 'AiAgentToolTest',
  props: {
    visible: { type: Boolean, default: false },
    scope: { type: String, default: 'self' },
    urls: { type: Object, required: true },
    tool: { type: Object, default: null }
  },
  data() {
    return { argsText: '{}', argsErr: '', testing: false, result: null }
  },
  computed: {
    statusCodeClass() {
      return this.result && this.result.status_code >= 200 && this.result.status_code < 300 ? 'code_ok' : 'code_bad'
    },
    isEmptyMcp() {
      const r = this.result || {}
      return (r.text === undefined || r.text === null || r.text === '') && r.structured === undefined
    }
  },
  methods: {
    fmtJson(v) {
      try { return JSON.stringify(v, null, 2) } catch (e) { return String(v) }
    },
    submitTest() {
      let args
      try {
        args = JSON.parse(this.argsText || '{}')
        this.argsErr = ''
      } catch (e) {
        this.argsErr = 'args 不是合法 JSON'
        return
      }
      this.testing = true
      this.result = null
      this.$tools.asyncPost(this, this.urls.toolsTest,
        agentBody({ tool_id: this.tool.tool_id, args })).then((res) => {
        if (res.data.code == 0) this.result = res.data.data || {}
        this.testing = false
      }).catch((err) => {
        this.testing = false
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '联调请求失败，请稍后重试' })
      })
    }
  },
  watch: {
    visible(v) {
      if (v) { this.argsText = '{}'; this.argsErr = ''; this.testing = false; this.result = null }
    }
  }
}
</script>

<style lang="less" scoped>
.test_head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  .t_name { font-weight: 600; }
}
.result_box {
  border-top: 1px solid #ebeef5;
  padding-top: 8px;
  h4 { margin: 8px 0; font-size: 14px; }
  h5 { margin: 10px 0 6px; font-size: 13px; color: #606266; }
}
.kv {
  display: flex;
  padding: 3px 0;
  font-size: 13px;
  .k { width: 80px; flex-shrink: 0; color: #909399; }
}
.code_ok { color: #67c23a; font-weight: 600; }
.code_bad { color: #f56c6c; font-weight: 600; }
.json_err { color: #f56c6c; font-size: 12px; }
.field_tip { color: #909399; font-size: 12px; }
.stream_pre {
  max-height: 260px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  background: #f5f7fa;
  padding: 8px;
  font-size: 12px;
  margin: 0 0 8px;
}
.mono { font-family: Consolas, Monaco, monospace; }
</style>
